import { actions } from './actions'

const menuSelectedState = (state = { selectedMenu: '/employers' }, action) => {
  switch (action.type) {
    case actions.set:
      return Object.assign({}, state.menuSelectedState, { selectedMenu: action.menuSelectedState.selectedMenu })
    default:
      return state
  }
}

export default menuSelectedState



// WEBPACK FOOTER //
// ./src/store/menu-selected/reducer.js